import { render } from "./content-logs-detail-page.vue?vue&type=template&id=918ff004"
import script from "./content-logs-detail-page.vue?vue&type=script&lang=ts"
export * from "./content-logs-detail-page.vue?vue&type=script&lang=ts"

import "./content-logs-detail-page.vue?vue&type=style&index=0&id=918ff004&lang=less"
script.render = render

export default script